import { Component, Input } from '@angular/core';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';

@Component({
    selector: 'app-basic-information-details-card',
    templateUrl: './basic-information-details-card.template.html',
    styleUrls: ['./basic-information-details-card.style.scss'],
})
export class BasicInformationDetailsCardComponent {
    @Input() timeOffPolicy = new TimeOffPolicy();
    @Input() editMode = false;
    @Input() isLoading = false;
}
